import { useEffect } from "react";
import { useMoralis } from "react-moralis";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { GiftOutlined } from "@ant-design/icons";
import Account from "components/Account/Account";
import Chains from "components/Chains";
//import TokenPrice from "components/TokenPrice";
import ERC20Balance from "components/ERC20Balance";
import ERC20Transfers from "components/ERC20Transfers";
import DEX from "components/DEX";
import NextNFT from "components/NextNFT";
import NextDAO from "components/NextDAO";
import Wallet from "components/Wallet";
import { Layout, Tabs, Image, Button, message, Modal } from "antd";
import "antd/dist/antd.css";
import NativeBalance from "components/NativeBalance";
import "./style.css";
import QuickStart from "components/QuickStart";
import Contract from "components/Contract/Contract";
import Text from "antd/lib/typography/Text";
import Ramper from "components/Ramper";
import MenuItems from "./components/MenuItems";
import robot from './asset/robot.png';
import mintAll from './asset/abi/mintAll.json';
import LayerZeroEndpointInfo from './asset/abi/layerZeroEndpoint.json';
import NFTClonableBridgeInfo from './asset/abi/NFTClonableBridge.json';

const { Header, Footer } = Layout;

const styles = {
  content: {
    display: "flex",
    justifyContent: "center",
    fontFamily: "Roboto, sans-serif",
    color: "#041836",
    marginTop: "70px",
    padding: "10px",
  },
  header: {
    position: "fixed",
    zIndex: 1,
    width: "100%",
    background: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontFamily: "Roboto, sans-serif",
    borderBottom: "2px solid rgba(0, 0, 0, 0.06)",
    padding: "0 10px",
    boxShadow: "0 1px 10px rgb(151 164 175 / 10%)",
  },
  headerRight: {
    display: "flex",
    gap: "20px",
    alignItems: "center",
    fontSize: "15px",
    fontWeight: "600",
  },
  logo: {
    display: "flex",
    flexDirection: 'row',
    alignItems: "center",
    width: '300px',
    fontSize: "30px",
    textShadow: "5px 5px 5px black, 0px 0px 2px black",
    color: "white",
    fontStyle: "italic"
  },
  robot: {
    height: '40px',
  }
};
const App = ({ isServerInfo }) => {
  const { isWeb3Enabled, enableWeb3, isAuthenticated, isWeb3EnableLoading, account, web3, chainId } = useMoralis();

  const chainMap = {'0x1':'1',     "0x38":"2",     "0xa86a":"6",     "0x89":"9",        "0xa4b1":"10",      "0x0a":"11", 
                    '0x4':'10001', "0x61":"10002", "0xa869":"10006", "0x13881":"10009", "0x66eeb": "10010", "0x45": "10011"} 

  const IsMainnet = window.location.origin.indexOf("test") < 0 && window.location.origin.indexOf("localhost") < 0;
  const isEthereum = () => {
    return chainId === '0x1' || chainId === '0x4';
  }

  const getEthEndpointId = () => {
    return IsMainnet ? 1 : 10001;
  }

  if (chainId != null) {
    if ((IsMainnet && parseInt(chainMap[chainId]) > 11) || (!IsMainnet && parseInt(chainMap[chainId]) < 10001)) {
      message.warning(IsMainnet ? "Please connect mainnet" : "Please connect testnet");
    }
  }

  const layerZeroEndpointAddress = LayerZeroEndpointInfo.multiAddressess[IsMainnet ? "mainnet" : "testnet"][chainId];   
  LayerZeroEndpointInfo.address = layerZeroEndpointAddress; 

  useEffect(() => {
    const connectorId = window.localStorage.getItem("connectorId");
    if (isAuthenticated && !isWeb3Enabled && !isWeb3EnableLoading) enableWeb3({ provider: connectorId });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, isWeb3Enabled]);

  const claimNFT = () => {
    const mintAllContract = new web3.eth.Contract(mintAll.abi, mintAll.address);
    mintAllContract.methods.mint().send({from: account})
    .on('transactionHash', function(hash){
      console.log(hash);
    })
    .on('confirmation', function(confirmationNumber, receipt){
      console.log(confirmationNumber, receipt);
    })
    .on('receipt', function(receipt){
      console.log(receipt);
    })
    .on('error', function(error, receipt) { 
      console.log(error, receipt);
    });
  }

  const checkBridge = () => {
    const layerZeroEndpoint = new web3.eth.Contract(LayerZeroEndpointInfo.abi, LayerZeroEndpointInfo.address);
    const ethEndpointId = getEthEndpointId();
    const peerAddr = NFTClonableBridgeInfo.multiAddressess[IsMainnet ? "mainnet" : "testnet"][ethEndpointId === 1 ? '0x1' : '0x4'];
    console.log(ethEndpointId, peerAddr)
    layerZeroEndpoint.methods.hasStoredPayload(ethEndpointId, peerAddr).call().then(result => {
      if (result) {
        message.warning("The pathway of message from ethereum to current network is blocked.");
      } else {
        message.success("The pathway of message from ethereum to current network is smooth.");
      }
    });
  }

  const donate = () => {    
    Modal.info({
      title: 'Donation Information',
      content: (
        <div>
          <p>Eth Address: 0x19b0D52438eDF115C386aD78ef2C12BD40009e17</p><p/><p/>
          <p>Note: </p>
          <p>1: When the donation amount reaches 2 ETH or the number of donors reached 20, we will launch this DAPP to the mainnet of ethereum.</p><p/><p/>
          <p>2: The donation is only a donation, not an investment, but does not exclude future incentives.</p>
          <p>3: Even if the donation does not meet expectations, we will still launch the main network at the right time.</p>
        </div>
      ),
      onOk() {},
      width: 500
    });
  }

  return (
    <Layout style={{ height: "100vh", overflow: "auto" }}>
      <Router>
        <Header style={styles.header}>
          <div style={styles.logo}>
            <Image style={styles.robot} src={robot} />NEXT
          </div>
          <MenuItems />
          <div style={styles.headerRight}>
            {chainId === '0x4' ? <Button type='primary' onClick={() => claimNFT()}>Claim NFTs for testing</Button> : ''}
            {isEthereum() ? "" :  <Button type='primary' onClick={() => checkBridge()}>Check Bridge</Button>}
            <Chains />
            {/* <TokenPric
              address="0x1f9840a85d5af5bf1d1762f925bdaddc4201f984"
              chain="eth"
              image="https://cloudflare-ipfs.com/ipfs/QmXttGpZrECX5qCyXbBQiqgQNytVGeZW5Anewvh2jc4psg/"
              size="40px"
            /> */}
            {/* <NativeBalance /> */}
            <Account />
          </div>
        </Header>

        <div style={styles.content}>
          <Switch>
            <Route exact path="/quickstart">
              <QuickStart isServerInfo={isServerInfo} />
            </Route>
            <Route path="/wallet">
              <Wallet />
            </Route>
            <Route path="/1inch">
              <Tabs defaultActiveKey="1" style={{ alignItems: "center" }}>
                <Tabs.TabPane tab={<span>Ethereum</span>} key="1">
                  <DEX chain="eth" />
                </Tabs.TabPane>
                <Tabs.TabPane tab={<span>Binance Smart Chain</span>} key="2">
                  <DEX chain="bsc" />
                </Tabs.TabPane>
                <Tabs.TabPane tab={<span>Polygon</span>} key="3">
                  <DEX chain="polygon" />
                </Tabs.TabPane>
              </Tabs>
            </Route>
            <Route path="/erc20balance">
              <ERC20Balance />
            </Route>
            <Route path="/onramp">
              <Ramper />
            </Route>
            <Route path="/erc20transfers">
              <ERC20Transfers />
            </Route>
            <Route path="/nextNFT">
              <NextNFT />
            </Route>
            <Route path="/nextDAO">
              <NextDAO />
            </Route>
            <Route path="/contract">
              <Contract />
            </Route>
            <Route path="/">
              <Redirect to="/quickstart" />
            </Route>
            <Route path="/ethereum-boilerplate">
              <Redirect to="/quickstart" />
            </Route>
            <Route path="/nonauthenticated">
              <>Please login using the "Authenticate" button</>
            </Route>
          </Switch>
        </div>
      </Router>
      <Footer style={{ textAlign: "center" }}>
        <Text style={{ display: "block" }}>
          ⭐️ Please join us{" "}
          <a href="https://discord.gg/XZ9JyRGe" target="_blank" rel="noopener noreferrer">
            Discord
          </a>
        </Text>
      </Footer>
    </Layout>
  );
};

export const Logo = () => (
  <div style={{ display: "flex" }}>
    <svg width="60" height="38" viewBox="0 0 50 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M43.6871 32.3986C43.5973 32.4884 43.53 32.5782 43.4402 32.6905C43.53 32.6007 43.5973 32.5109 43.6871 32.3986Z"
        fill="black"
      /> 
      <path
        d="M49.7037 14.3715C49.5241 6.2447 42.7891 -0.17592 34.6624 0.00367768C31.0031 0.0934765 27.4784 1.53026 24.8294 4.06708C22.113 1.46291 18.4986 0.00367768 14.727 0.00367768C6.71246 0.00367768 0.202047 6.49164 0 14.5511V14.6633C0 20.8146 2.24497 26.2698 4.26545 30.0189C5.11853 31.5904 6.08387 33.117 7.13901 34.5762C7.5431 35.115 7.8574 35.564 8.10435 35.8559L8.39619 36.2151L8.48599 36.3273L8.50844 36.3498L8.53089 36.3722C10.2146 38.3253 13.1555 38.5498 15.1087 36.8886C15.1311 36.8661 15.1536 36.8437 15.176 36.8212C17.1291 35.0701 17.3312 32.0843 15.625 30.1087L15.6026 30.0638L15.423 29.8618C15.2658 29.6597 15.0189 29.3455 14.727 28.9414C13.9188 27.8189 13.178 26.6515 12.5269 25.4392C10.8881 22.4309 9.42888 18.6145 9.42888 14.7531C9.49623 11.8347 11.9432 9.52236 14.8617 9.58971C17.7128 9.65705 19.9802 11.9694 20.0251 14.8205C20.0476 15.5389 20.2272 16.2348 20.5415 16.8859C21.4844 19.3104 24.2232 20.5227 26.6478 19.5798C28.4438 18.8839 29.6336 17.1553 29.6561 15.2246V14.596C29.7683 11.6775 32.2153 9.38766 35.1562 9.47746C37.94 9.56726 40.1625 11.8122 40.2748 14.596C40.2523 17.6941 39.2645 20.7472 38.1421 23.1718C37.6931 24.1371 37.1992 25.08 36.6379 25.978C36.4359 26.3147 36.2787 26.5617 36.1665 26.6964C36.1216 26.7862 36.0767 26.8311 36.0542 26.8535L36.0318 26.876L35.9869 26.9433C37.6033 24.9004 40.5442 24.5412 42.5871 26.1576C44.4953 27.6617 44.9443 30.3781 43.6198 32.4211L43.6422 32.4435V32.3986L43.6647 32.3762L43.732 32.2864C43.7769 32.1966 43.8667 32.1068 43.9565 31.9721C44.1361 31.7027 44.3606 31.3435 44.6525 30.8945C45.3933 29.6822 46.0668 28.4026 46.673 27.1229C48.1097 24.0249 49.6812 19.5349 49.6812 14.5286L49.7037 14.3715Z"
        fill="#041836"
      />
      <path
        d="M39.7135 25.1249C37.1094 25.1025 34.9991 27.2127 34.9766 29.8169C34.9542 32.4211 37.0645 34.5313 39.6686 34.5538C41.1503 34.5538 42.5647 33.8578 43.4626 32.6905C43.53 32.6007 43.5973 32.4884 43.6871 32.3986C45.1015 30.221 44.4729 27.3025 42.2953 25.9107C41.532 25.3943 40.634 25.1249 39.7135 25.1249Z"
        fill="#B7E803"
      />
    </svg>
  </div>
);

export default App;
